import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../hooks/useStore'
import { ga4Title } from '../../../../shared/helpers'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { ga4DataType } from './types'
import dayjs, { Dayjs } from 'dayjs'

const MEDIA_START = 'MediaStart'
const MEDIA_STOP = 'MediaStop'
const VOD_SCREEN = 'Video Playback Screen'

export const VOD = 'VOD'

export default function useMediaEvent(playerType: 'VOD') {
  const [now, setNow] = useState<Dayjs | null>(null)
  const mediaEventSentRef = useRef(false)
  const ga4Data = playerType === VOD ? getVODPlayerData() : {}
  const screen = playerType === VOD ? VOD_SCREEN : ''

  const sendMediaStartEvent = () => {
    if (!mediaEventSentRef.current) {
      mediaEventSentRef.current = true
      setNow(dayjs())
      googleAnalytics4.sendMediaEvent(
        MEDIA_START.toLowerCase(),
        ga4Data,
        screen
      )
    }
  }

  useEffect(() => {
    return () => {
      if (mediaEventSentRef.current) {
        mediaEventSentRef.current = false
        const videoStreamingDuration = dayjs().diff(now, 'second')
        googleAnalytics4.sendMediaEvent(
          MEDIA_STOP.toLowerCase(),
          { ...ga4Data, video_streaming_duration: videoStreamingDuration },
          screen
        )
      }
    }
  }, [])

  return { sendMediaStartEvent }
}

function getVODPlayerData(): ga4DataType {
  const {
    seriesTitle,
    videoId,
    is_mvod,
    episodeTitle,
    legacyTpMediaId,
    contentType,
  } = useAppSelector((state) => state.content.videoDetails)
  const device = useAppSelector((state) => state.device)
  const deviceDistributor = device.distributor

  const ga4Data: ga4DataType = {
    video_player: `GA ${ga4Title(deviceDistributor)}${is_mvod ? ' MVOD' : ''}`,
    ...((seriesTitle || undefined) && { show_title: seriesTitle }),
    ...((episodeTitle || undefined) && { video_title: episodeTitle }),
    ...((legacyTpMediaId || undefined) && {
      video_tp_media_id: legacyTpMediaId,
    }),
    ...((contentType || undefined) && { video_type: contentType }),
    ...((videoId || undefined) && { pbs_content_id: videoId }),
  }
  return ga4Data
}

//TODO: Implement the method for liveplayer
/* function getLivePlayerData() {
  
} */
